import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isQueueCollapsed: false,
};

const queueSlice = createSlice({
  name: 'queue',
  initialState,
  reducers: {
    toggleQueueCollapse: state => {
      state.isQueueCollapsed = !state.isQueueCollapsed;
    },
    setQueueCollapse: (state, action) => {
      state.isQueueCollapsed = action.payload;
    },
  },
});

export const { toggleQueueCollapse, setQueueCollapse } = queueSlice.actions;

export default queueSlice.reducer;
